const filterUIConfig = {
  uiScheme: {
    "ui:classNames": "filters-container",
    search: {
      "ui:options": {
        label: false, // Oculta el título del campo
        placeholder: "Buscar...",
      },
    },
  },
};
const getProducerFilterUIConfig: any = (user: any) => {
  return filterUIConfig;
};
export default getProducerFilterUIConfig;
